
import Vue from 'vue';
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {SuspensionDetailsModel} from "@/api-client";
import {formatDate} from "@/formatting/dateFormatter";

@Component
export default class SuspensionDetails extends Vue {
    @Prop({required: true})
    details!: SuspensionDetailsModel;

    get state(): string {
        if (this.aboutToBeSuspended)
            return this.$ls.Endorsements_Suspension_Heading_AboutToBeSuspended;

        return this.$ls.Endorsements_Suspension_Heading_DocumentSuspended;
    }

    get suspendedUntil(): string {
        if (this.details.validUntil) {
            return this.$ls.Endorsements_Suspension_Text_UntilDate + ' ' + formatDate(this.details.validUntil);
        }
        return this.$ls.Endorsements_Suspension_Text_UntilIndefinitely
    }

    get aboutToBeSuspended(): boolean {
        return new Date() < this.details.startedOn;
    }
}
